export default "__VITE_ASSET__BR63$U7a__"